/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_Q1Inputs */

const en_to_yaml_faq_q1 = /** @type {(inputs: To_Yaml_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is the YAML output valid?`)
};

const ko_to_yaml_faq_q1 = /** @type {(inputs: To_Yaml_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력된 YAML은 유효한가요?`)
};

const ja_to_yaml_faq_q1 = /** @type {(inputs: To_Yaml_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力されたYAMLは有効ですか？`)
};

/**
* | output |
* | --- |
* | "Is the YAML output valid?" |
*
* @param {To_Yaml_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_q1 = /** @type {((inputs?: To_Yaml_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_q1(inputs)
	if (locale === "ko") return ko_to_yaml_faq_q1(inputs)
	return ja_to_yaml_faq_q1(inputs)
});